import { Box } from '@mui/material';

export const Radiology = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
